/**
 * Configuration constants for Morph Git SDK
 */

/** Default proxy URL for Morph git operations */
export const DEFAULT_PROXY_URL = 'https://repos.morphllm.com';

/**
 * Validate API key format
 */
export function validateApiKey(apiKey: string): void {
  if (!apiKey) {
    throw new Error('API key is required');
  }
  
  if (!apiKey.startsWith('sk-') && !apiKey.startsWith('morph-')) {
    throw new Error('Invalid API key format. Expected: sk-... or morph-...');
  }
}
